/**
 * Uren-afwijking-drempel: als de werkelijke uren meer dan 15% EN minstens 30 min
 * afwijken van de geplande uren, moet de monteur een reden opgeven. Bij een
 * afwezige dag (isAfwezig) is een reden ALTIJD verplicht. Zonder planning-
 * referentie (geplandeUren == null) valt er niets te toetsen. Gedeeld tussen API
 * (validatie) en portal (UI) zodat er geen drift ontstaat tussen wat de UI toont
 * en wat de server accepteert. Analoog aan travel-variance.ts.
 */

export const UREN_VARIANCE_PERCENT_THRESHOLD = 0.15 // 15%
export const UREN_VARIANCE_MIN_MINUTES = 30

export interface UrenVarianceInput {
  /** Geplande uren (uit plannedStart/plannedEnd minus pauze), of null als onbekend. */
  geplandeUren: number | null
  /** Werkelijk gewerkte uren (netto, na pauze). */
  werkelijkeUren: number
  /** True als de dag als afwezig/niet-gewerkt is gemarkeerd. */
  isAfwezig: boolean
}

export function requiresUrenAfwijkingReden(input: UrenVarianceInput): boolean {
  if (input.isAfwezig) return true
  const { geplandeUren, werkelijkeUren } = input
  if (geplandeUren == null) return false
  if (geplandeUren === 0) {
    // Geen geplande uren maar wel werkelijke uren: dat is een afwijking als er
    // substantieel gewerkt is.
    return werkelijkeUren * 60 >= UREN_VARIANCE_MIN_MINUTES
  }
  const deltaUren = Math.abs(werkelijkeUren - geplandeUren)
  const deltaMinuten = deltaUren * 60
  const ratio = deltaUren / geplandeUren
  return ratio > UREN_VARIANCE_PERCENT_THRESHOLD && deltaMinuten >= UREN_VARIANCE_MIN_MINUTES
}
